import React from 'react';
import { ChevronRight } from 'lucide-react';
import { colors } from '../../constants/theme';
import { DataSource } from '../../types/agent.types';

interface LeftMenuContextProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedStore: string;
  setSelectedStore: (store: string) => void;
  dataSources: DataSource[];
}

const LeftMenuContext: React.FC<LeftMenuContextProps> = ({
  isOpen,
  setIsOpen,
  selectedStore,
  setSelectedStore,
  dataSources
}) => {
  return (
    <div 
      className={`border-r transition-all panel-transition ${isOpen ? 'w-72' : 'w-12'}`} 
      style={{ borderColor: colors.ui.border }}
    >
      <div className="h-full overflow-y-auto">
        {/* 店舗選択 */}
        <div className="p-4 border-b" style={{ borderColor: colors.ui.border }}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-semibold text-sm" style={{ color: colors.text.primary }}>
              店舗選択
            </h3>
            <button onClick={() => setIsOpen(!isOpen)}>
              <ChevronRight 
                size={16} 
                style={{ color: colors.text.secondary }}
                className={`transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
              />
            </button>
          </div>
          {isOpen && (
            <select 
              className="w-full p-2 text-sm border rounded-lg"
              style={{ borderColor: colors.ui.border, color: colors.text.primary }}
              value={selectedStore}
              onChange={(e) => setSelectedStore(e.target.value)}
            >
              <option value="all">全店舗</option>
              <option value="cluster1">都市型店舗</option>
              <option value="cluster2">郊外型店舗</option>
              <option value="shibuya">渋谷店</option>
              <option value="shinjuku">新宿店</option>
            </select>
          )}
        </div>

        {/* データソース */}
        {isOpen && (
          <>
            <div className="p-4 border-b" style={{ borderColor: colors.ui.border }}>
              <h3 className="font-semibold text-sm mb-3" style={{ color: colors.text.primary }}>
                データソース接続
              </h3>
              <div className="space-y-2">
                {dataSources.map((source, idx) => (
                  <div key={idx} className="flex items-center justify-between text-xs">
                    <div className="flex items-center gap-2">
                      <div 
                        className={`w-2 h-2 rounded-full`}
                        style={{ 
                          backgroundColor: source.status === 'connected' ? colors.ui.success : 
                                         source.status === 'delayed' ? colors.ui.warning : colors.accent.red 
                        }}
                      />
                      <span style={{ color: colors.text.primary }}>{source.name}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <span style={{ color: colors.text.secondary }}>{source.records}</span>
                      <span style={{ color: colors.text.secondary }}>{source.sync}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 分析履歴 */}
            <div className="p-4">
              <h3 className="font-semibold text-sm mb-3" style={{ color: colors.text.primary }}>
                直近の実行履歴
              </h3>
              <div className="space-y-2">
                <div className="p-2 rounded-lg" style={{ backgroundColor: colors.ui.bgSecondary }}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-medium" style={{ color: colors.text.primary }}>
                      52週計画最適化
                    </span>
                    <span className="text-xs" style={{ color: colors.text.secondary }}>2時間前</span>
                  </div>
                  <div className="text-xs" style={{ color: colors.ui.success }}>実行完了</div>
                </div>
                <div className="p-2 rounded-lg" style={{ backgroundColor: colors.ui.bgSecondary }}>
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-medium" style={{ color: colors.text.primary }}>
                      棚割り更新
                    </span>
                    <span className="text-xs" style={{ color: colors.text.secondary }}>5時間前</span>
                  </div>
                  <div className="text-xs" style={{ color: colors.ui.success }}>実行完了</div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LeftMenuContext;
